import React from 'react';
import {Input} from "react-materialize";

export default class Toggle extends React.Component {

    onChange(e) {
        this.props.onChange(e.target.checked)
    }

    render() {
        let checkAttributes = {};
        if (this.props.formData) {
            checkAttributes = {
                defaultChecked: this.props.formData,
            }
        }

        return (
            <div style={{margin: "12px 0"}}>
                <label>{this.props.schema.title}</label>
                <Input
                    type="switch"
                    name={this.props.idSchema.$id}
                    value={this.props.name}
                    {...checkAttributes}
                    label={this.props.schema.title}
                    disabled={this.props.schema.locked !== undefined ? this.props.schema.locked : false}
                    offLabel={"Active"}
                    onLabel={"Archived"}
                    onChange={this.onChange.bind(this)}
                />
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/forms/fields/Toggle.js